import { FormConfig } from '@jd/x-coreui';

export const formConfig: FormConfig = {
  fields: [
    {
      type: 'radioGroup',
      fieldName: 'isInfluenceOperation',
      label: '问题影响',
      validatorRules: [{ required: true, message: '请选择问题影响' }],

      options: [
        { label: '影响运营', value: 1 },
        { label: '不影响运营', value: 0 },
      ],
    },
    {
      type: 'textarea',
      fieldName: 'description',
      label: '问题描述',
      validatorRules: [
        { required: true, message: '请输入问题描述' },
        { max: 50, message: '问题描述最多50字' },
      ],

      placeholder: '请输入问题描述',
      maxLength: 50,
      showCount: true,
    },
    {
      type: 'dateTime',
      fieldName: 'appointmentRepairTime',
      label: '预约维修时间',
      format: 'YYYY-MM-DD HH:mm',
    },
  ],
};

export type ValidationCtx = {
  formRef: any;
  vehicleName: string;
  uploading: boolean;
  fileList: any[];
};

type WhenPredicate = (ctx: ValidationCtx) => boolean;

/**
 * 维修单的校验条件与提示信息的映射关系
 */
export const ValidationMap: { when: WhenPredicate; message: string }[] = [
  {
    when: (ctx) => !ctx.vehicleName,
    message: '获取车牌号异常, 请退出重试',
  },
  {
    when: (ctx) => !!ctx.uploading,
    message: '请等待文件上传完成',
  },
  {
    when: (ctx) =>
      ctx.formRef.current?.getFieldValue('description')?.trim() === '',
    message: '请输入问题描述',
  },
  {
    when: (ctx) => ctx.fileList?.length === 0,
    message: '请至少上传一张图片或视频',
  },
];
